var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c(
        "label",
        { staticClass: "form-control-label", attrs: { for: _vm.id } },
        [_c("b", [_vm._v(_vm._s(_vm.label))])]
      ),
      _vm._v(" "),
      _c("multiselect", {
        attrs: {
          placeholder: _vm.placeholder,
          "track-by": "user.firstName",
          options: _vm.options,
          label: "user.firstName",
          "show-labels": false,
          searchable: true
        },
        scopedSlots: _vm._u([
          {
            key: "singleLabel",
            fn: function(props) {
              return [
                _c("b-avatar", {
                  attrs: {
                    square: "",
                    src:
                      "data:" +
                      props.option.imagenContentType +
                      ";base64," +
                      props.option.imagen
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _c("span", [_vm._v(_vm._s(props.option.user.firstName))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(props.option.user.lastName))])
                ])
              ]
            }
          },
          {
            key: "option",
            fn: function(props) {
              return [
                _c(
                  "div",
                  [
                    _c("b-avatar", {
                      attrs: {
                        square: "",
                        src:
                          "data:" +
                          props.option.imagenContentType +
                          ";base64," +
                          props.option.imagen
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(props.option.user.firstName))]),
                    _c("span", [_vm._v(_vm._s(props.option.user.lastName))])
                  ],
                  1
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }